import globals from "../config/appconfig";
import axios from "axios";
import Utils from "../utils/Utils";

export default class AnagraficaService {

    static urlGetAnagraficheAndCandidati = globals["app-url-backend-anagrafica"] + "/anagraficheAndCandidati"
    static urlGetAllCandidati = globals["app-url-backend-anagrafica"] + "/candidati"
    static urlGetSintesiCandidati = globals["app-url-backend-anagrafica"] + "/datisintesicandidati"

    static getAnagraficheAndCandidati(params) {
        return axios.get(this.urlGetAnagraficheAndCandidati + Utils.addQueryParamsToRequestUrl(params))
    }
    static getAllCandidati(params) {
        return axios.get(this.urlGetAllCandidati + Utils.addQueryParamsToRequestUrl(params))
    }
    static getCandidatoByCodiceFiscale(params) {
        return axios.get(this.urlGetSintesiCandidati + Utils.addQueryParamsToRequestUrl(params))
    }
    static getCandidato(idCandidato) {
        return axios.get(this.urlGetAllCandidati + "/"+ idCandidato)
    }

    static inserisciCandidato(jsonInsert) {
        return axios.post(this.urlGetAllCandidati,jsonInsert)
    }

    static modificaCandidato(jsonInsert) {
        return axios.put(this.urlGetAllCandidati,jsonInsert)
    }

    static getSintesiAssistenti(params) {
        return axios.get(this.urlGetSintesiCandidati + Utils.addQueryParamsToRequestUrl(params))
    }
}
